import { render, staticRenderFns } from "./UpdateDocumentBeneficiaire.vue?vue&type=template&id=1749636f&"
import script from "./UpdateDocumentBeneficiaire.vue?vue&type=script&lang=ts&"
export * from "./UpdateDocumentBeneficiaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports